import PropTypes from 'prop-types';

const tagPropType = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  type: PropTypes.number,
  subscriptionId: PropTypes.number,
  alertCount: PropTypes.number,
  deviceCount: PropTypes.number,
});

export default { tagPropType };
